import { useState } from 'react';
import styled from 'styled-components';

/* 컴포넌트 */
import StandArea from 'components/client/Message/StandardArea';
import CustomArea from 'components/client/Message/CustomArea';

export default function CustomerMessage() {
  const MsgOpt = [
    'Inspection Message', 'Before Services Message', 'After Services Message', 'After 3rd Week of Services', 'Inspection message (For First Time)', 'After Services Message (Plan)'
  ];

  const [selectedOpt, setSelectedOpt] = useState('default');

  const handleSelectChange = (e) => {
    const value = e.target.value;

    if (value === 'default') {
      setSelectedOpt('default');
    } else {
      const optionIndex = MsgOpt.findIndex((opt) => opt === value);

      setSelectedOpt(optionIndex);
    }
  };

  return (
    <ContentWrap>
      <div className='content-inner'>
        {/* 타이틀 */}
        <div className='title'>
          <div className='title-head'>
            <i/>
            <h4>Message for the Customers</h4>
          </div>
        </div>
        {/* 컨텐츠 */}
        <div className='content'>
          <div className='util-box'>
            <div className='util-menu'>
              <select className='message' onChange={handleSelectChange}>
                <option value='default'>Select Option</option>
                {MsgOpt?.map((item) => (
                  <option key={item} value={item}>{item}</option>
                ))}s
              </select>
            </div>
          </div>
          <div className='message-content'>
            {selectedOpt === 'default' ? (
              <div className='empty'>
                <p>Please select a message option to view the template and customize fields.</p>
              </div>
            ) : (
              <>
                <StandArea selectedOption={selectedOpt}/>
                <CustomArea selectedOption={selectedOpt}/>
              </>
            )}
          </div>
        </div>
      </div>
    </ContentWrap>
  )
}

const ContentWrap = styled.div`
  position: relative;
  flex: 1;
  background: #fff;
  font-family: 'Apple SD Gothic Neo', sans-serif;

  .content-inner {
    position: relative;

    .content {
      height: auto !important;

      .util-button {
        position: relative;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        gap: 0 10px;

        .util-btn {
          padding: 0 20px;
          height: 40px;
          line-height: 40px;
          font-weight: 600;
          font-size: 14px;
          color: #ffffff;
          background: #a5a5a5;
          border-radius: 4px;

          &.primary {
            background: #056eae;
          }
        }
      }

      .message-content {
        position: relative;
        display: flex;
        padding: 20px;
        gap: 0 60px;

        .standard-area {
          position: relative;
          flex: 1;

          p {
            font-weight: 400;
            line-height: 1.5;
            white-space: pre-line;
          }
        }

        .custom-area {
          position: relative;
          flex: 1;
          padding: 0 20px;

          .phone-section {
            margin-bottom: 20px;
          }

          .phone-header {
            position:relative;
            display:flex;
            align-items: center;
            justify-content: space-between;
            
            label {
              font-weight: bold;
              color: #333;
            }

            .add-btn {
              display:block;
              background: #007bff;
              color: white;
              border: none;
              padding: 6px 12px;
              border-radius: 4px;
              cursor: pointer;
              font-size: 12px;
            }
          }
          
          .add-phone-btn:hover {
            background: #0056b3;
          }

          .phone-list {
            margin-top:10px;
            display: flex;
            flex-direction: column;
            gap: 10px;


            .phone-input-group {
              display: flex;
              align-items: center;
              gap: 10px;
            }

            .phone-input {
              flex:1;
              padding: 0 10px;
              border: 1px solid #ddd;
              height:30px;
              line-height:30px;
              border-radius: 4px;
              font-size: 14px;
              font-weight:500;
              color:#111;
            }

            .remove-phone-btn {
              background: #dc3545;
              color: white;
              border: none;
              width: 24px;
              height: 24px;
              border-radius: 50%;
              cursor: pointer;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 16px;
            }

            .remove-phone-btn:hover {
              background: #c82333;
            }

            .toggle-phones-btn {
              background: #f8f9fa;
              border: 1px solid #dee2e6;
              padding: 8px 16px;
              border-radius: 4px;
              cursor: pointer;
              color: #6c757d;
              font-size: 14px;
            }

            .toggle-phones-btn:hover {
              background: #e9ecef;
            }
          }
          
          .input-in {
            position: relative;
            padding: 15px 0;

            label {
              margin-bottom: 10px;
              display: block;
              font-weight: 500;
              font-size: 1.1rem;
              color: #111;
            }

            input {
              width: 100%;
              height: 40px;
              line-height: 40px;
              padding: 0 10px;
              font-weight: 400;
              font-size: 1rem;
              color: #111;
              border-radius: 4px;
              outline: none;
              border: 1px solid #444;

              &::placeholder {
                font-weight: 400;
                font-size: 1rem;
                color: #111;
              }
            }
          }

          .input-in + .input-in {
            border-top: 1px solid #666;
          }

          .send-btn {
            margin-top: 30px;
            display: block;
            width: 100%;
            height: 40px;
            line-height: 40px;
            background: #0072B9;
            font-weight: 500;
            font-size: 18px;
            color: #fff;
            border-radius: 10px;
          }
        }

        .empty {
          flex: 1;

          p {
            padding: 150px 0;
            display: block;
            font-weight: 500;
            font-size: 1.2rem;
            color: #0072b9;
            text-align: center;
          }
        }
      }
    }
  }
`;